import React from 'react';
import InputForm from '../../../../../components/form/InputForm';
import SelectForm from '../../../../../components/form/SelectForm';
import Anchor from '../../../../../components/link/Anchor';
import Select from '../../../../../components/input/Select';
import { PRODUCT_EDIT_URL_PATH, ORDER_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  PRODUCT_STATUS_TEXT,
  PRODUCT_MANAGEMENT_TYPE_TEXT,
  PRODUCT_STOCK_RECOVER_PRODUCT_STATUS_SELECT_LIST,
  PRODUCT_OPTION_STOCK_RECOVER_PRODUCT_STATUS_SELECT_LIST,
  PRODUCT_OPTION_STATUS_TEXT,
  PRODUCT_UNLIMITED_STOCK_VALUE,
  PRODUCT_OPTION_STATUS,
  PRODUCT_STATUS,
  PRODUCT_MANAGEMENT_TYPE_SELECT_LIST,
  PRODUCT_MANAGEMENT_TYPE,
} from '../../../../../constants/service/app/productConstants';
import { openNewWindow, setDash, setDetailPageUrl, setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';

/**
 *  판매 취소 할 상품 주문건에 재고 및 상품상태 리스트 컬럼
 */
const columns = (data) => {
  const { form, setOrderItemList, orderItemList } = data;

  return [
    {
      title: '번호',
      dataIndex: 'no',
      render: (value, record) => ({
        children: record.productRowSpan ? value : undefined,
        props: {
          rowSpan: record.productRowSpan,
        },
      }),
    },
    {
      title: '상품명',
      dataIndex: 'productName',
      render: (value, record) => ({
        children: record.productRowSpan ? (
          <Anchor
            text={value}
            color="primary"
            isUnderLine={true}
            onClick={() => openNewWindow(setDetailPageUrl(PRODUCT_EDIT_URL_PATH, record.productId))}
          />
        ) : undefined,
        props: {
          rowSpan: record.productRowSpan,
        },
      }),
    },
    {
      title: '옵션정보',
      dataIndex: 'productOption',
      render: (value, record) => ({
        children: record.productOptionRowSpan ? setDash(value) : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
    {
      title: '상품주문번호',
      dataIndex: 'orderItemId',
      render: (value) => (
        <Anchor
          text={value}
          color="primary"
          isUnderLine={true}
          onClick={() => openNewWindow(setDetailPageUrl(ORDER_DETAIL_URL_PATH, value))}
        />
      ),
    },
    {
      title: '구매 당시 상품타입',
      dataIndex: 'orderItemProductType',
      render: (value, record) => ({
        children: record.productOptionRowSpan ? setDash(PRODUCT_MANAGEMENT_TYPE_TEXT[value]) : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
    {
      title: '현재 상품타입',
      dataIndex: 'productType',
      render: (value, record) => ({
        children: record.productOptionRowSpan
          ? record.isDisabledEdit
            ? '-'
            : setDash(PRODUCT_MANAGEMENT_TYPE_TEXT[value])
          : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
    {
      title: '변경될 상품타입',
      dataIndex: 'newProductType',
      render: (value, record) => ({
        children: record.productOptionRowSpan ? (
          record.isDisabledEdit ? (
            '-'
          ) : (
            <Select
              list={PRODUCT_MANAGEMENT_TYPE_SELECT_LIST}
              value={value}
              onChange={(value) => {
                /**
                 *  풀필먼트였는데 재고수량 부족 현상으로 인해
                 *  입점/무제한 재고로 변경된 경우
                 */
                const isFulfillmentToBrandCase =
                  record.orderItemProductType !== PRODUCT_MANAGEMENT_TYPE.ENTER &&
                  record.productType === PRODUCT_MANAGEMENT_TYPE.ENTER &&
                  value !== PRODUCT_MANAGEMENT_TYPE.ENTER;

                /**
                 *  풀필먼트 -> 입점으로 변경한 후에 다시
                 *  입점 -> 풀필먼트 타입으로 변경한 경우
                 */
                const isRevokeProductType =
                  record.orderItemProductType !== PRODUCT_MANAGEMENT_TYPE.ENTER &&
                  value === PRODUCT_MANAGEMENT_TYPE.ENTER;

                /**
                 *  풀필먼트였는데 재고수량 부족 현상으로 인해
                 *  입점/무제한 재고로 변경된후에
                 *  다시 풀필먼트 상품관리타입으로 설정하는 경우의
                 *  재고 수량 값
                 */
                const brandToFulfillmentStockCount =
                  isFulfillmentToBrandCase &&
                  orderItemList.reduce((acc, item) => {
                    if (item.productId === record.productId && item.productOptionId === record.productOptionId) {
                      acc += item.quantity;
                    }
                    return acc;
                  }, 0);

                const list = orderItemList.map((item) => {
                  /**
                   *  같은 상품 및 옵션인 경우 같은 값으로 업데이트 하기 위한 조건
                   */
                  const updateDuplicateCondition =
                    item.productId === record.productId && item.productOptionId === record.productOptionId;
                  let newStockCount = item.newStockCount;
                  let minStockCount = item.minStockCount;
                  let maxStockCount = item.maxStockCount;

                  if (updateDuplicateCondition) {
                    /**
                     *  풀필먼트 였는데 재고수량 부족 현상으로 인해
                     *  입점/무제한 재고로 변경된 경우
                     */
                    if (brandToFulfillmentStockCount) {
                      newStockCount = brandToFulfillmentStockCount;
                      minStockCount = item.stockCount === PRODUCT_UNLIMITED_STOCK_VALUE ? 0 : item.stockCount;
                      maxStockCount = brandToFulfillmentStockCount;
                    } else if (isRevokeProductType) {
                      newStockCount =
                        item.stockCount === PRODUCT_UNLIMITED_STOCK_VALUE ? item.stockCount : item.newStockCount;
                      minStockCount =
                        item.stockCount === PRODUCT_UNLIMITED_STOCK_VALUE ? item.stockCount : item.minStockCount;
                      maxStockCount =
                        item.stockCount === PRODUCT_UNLIMITED_STOCK_VALUE ? item.stockCount : item.maxStockCount;

                      /**
                       *  변경할 상태 from 초기화
                       */
                      form.resetFields([`newStatus_${record.orderItemId}`]);
                    }
                  }

                  return {
                    ...item,
                    newProductType: updateDuplicateCondition ? value : item.newProductType,
                    newStockCount,
                    minStockCount,
                    maxStockCount,
                  };
                });
                setOrderItemList(list);
              }}
            />
          )
        ) : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
    {
      title: '주문한 수량',
      dataIndex: 'quantity',
    },
    {
      title: '현재 수량',
      dataIndex: 'stockCount',
      render: (value, record) => ({
        children: record.productOptionRowSpan
          ? record.isDisabledEdit
            ? '-'
            : value === PRODUCT_UNLIMITED_STOCK_VALUE
              ? '무제한'
              : setNumberWithComma(value)
          : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
    {
      title: '변경될 수량',
      dataIndex: 'newStockCount',
      render: (value, record) => ({
        children: record.productOptionRowSpan ? (
          record.isDisabledEdit ? (
            '-'
          ) : value !== PRODUCT_UNLIMITED_STOCK_VALUE ? (
            <InputForm
              form={form}
              type="number"
              name={`newStockCount_${record.orderItemId}`}
              rules={[formRequiredRules(true, null, false)]}
              size="large"
              min={record.minStockCount}
              max={record.maxStockCount}
              addonAfter="개"
              initialValue={value}
              onChange={(value) => {
                /**
                 *  변경될 수량으로 -1을 입력하게 되면
                 *  무제한값이랑 겹치기 때문에 업데이트 방지
                 */
                if (value === PRODUCT_UNLIMITED_STOCK_VALUE) return;

                const list = orderItemList.map((item) => {
                  /**
                   *  같은 상품 및 옵션인 경우 같은 값으로 업데이트 하기 위한 조건
                   */
                  const updateDuplicateCondition =
                    item.productId === record.productId && item.productOptionId === record.productOptionId;

                  /**
                   *  변경될 수량으로 0 입력시 변경될 상태를 품절로 변경
                   */
                  let newStatus = item.newStatus;
                  if (updateDuplicateCondition && value === 0) {
                    newStatus = record.productOptionId ? PRODUCT_OPTION_STATUS.SOLD_OUT : PRODUCT_STATUS.SOLD_OUT;
                  }

                  return {
                    ...item,
                    newStatus,
                    newStockCount: updateDuplicateCondition ? value : item.newStockCount,
                  };
                });
                setOrderItemList(list);
              }}
            />
          ) : (
            '무제한'
          )
        ) : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
    {
      title: '현재 상태',
      dataIndex: 'status',
      render: (value, record) => ({
        children: record.productOptionRowSpan
          ? record.isDisabledEdit
            ? '-'
            : record.productOption
              ? setDash(PRODUCT_OPTION_STATUS_TEXT[value])
              : setDash(PRODUCT_STATUS_TEXT[value])
          : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
    {
      title: '변경될 상태',
      dataIndex: 'newStatus',
      render: (value, record) => ({
        children: record.productOptionRowSpan ? (
          record.isDisabledEdit ? (
            '-'
          ) : (
            <SelectForm
              form={form}
              name={`newStatus_${record.orderItemId}`}
              rules={[
                {
                  validator: (rule, value, cb) => {
                    if (
                      record.newStockCount === 0 &&
                      ((!record.productOption && value === PRODUCT_STATUS.NOW_ON_SALE) ||
                        (record.productOption && value === PRODUCT_OPTION_STATUS.ACTIVE))
                    ) {
                      cb('변경될 수량이 0인 경우 변경될 상태는 품절이 되어야 합니다.');
                    } else cb();
                  },
                },
              ]}
              list={
                record.productOption
                  ? PRODUCT_OPTION_STOCK_RECOVER_PRODUCT_STATUS_SELECT_LIST
                  : PRODUCT_STOCK_RECOVER_PRODUCT_STATUS_SELECT_LIST
              }
              initialValue={value}
              onChange={(value) => {
                const list = orderItemList.map((item) => ({
                  ...item,
                  newStatus:
                    item.productId === record.productId && item.productOptionId === record.productOptionId
                      ? value
                      : item.newStatus,
                }));
                setOrderItemList(list);
              }}
              isTable
            />
          )
        ) : undefined,
        props: {
          rowSpan: record.productOptionRowSpan,
        },
      }),
    },
  ];
};

export default columns;
